// @ts-nocheck
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { CheckIcon } from '@pleio/icons/check'
import { DeleteSmallIcon } from '@pleio/icons/delete-small'
import { EditSmallIcon } from '@pleio/icons/edit-small'

import Flexer from 'js/components/Flexer/Flexer'
import IconButton from 'js/components/IconButton'

import type { EventItemViewFragment } from '../EventPage/EventItemView.fragment.generated'

import styles from './TabElement.module.css'

type Props = {
    name: NonNullable<
        NonNullable<EventItemViewFragment['slotsAvailable']>[number]
    >['name']
    onClick: any
    isActive: boolean
    slotIndex: number
    setSlotsAvailable: any
    setActiveSlotIndex: any
    [key: string]: any
}

const TabElement = ({
    name,
    onClick,
    isActive,
    slotIndex,
    setSlotsAvailable,
    setActiveSlotIndex,
    ...rest
}: Props) => {
    const editButton = useRef()

    const { t } = useTranslation()

    const [editing, setEditing] = useState()
    const toggleEdit = () => setEditing(!editing)
    useEffect(() => {
        if (!editing) {
            editButton?.current?.focus()
        }
    }, [editing])

    useEffect(() => {
        if (!isActive) {
            setValue(name)
        }
    }, [isActive])

    const [value, setValue] = useState(name)
    const changeValue = (evt) => setValue(evt.target.value)

    const submitName = (evt) => {
        evt.stopPropagation()
        const name = value.trim()
        if (name) {
            setSlotsAvailable((prev) =>
                prev.map((slot, idx) =>
                    idx === slotIndex ? { ...slot, name } : slot,
                ),
            )
        } else {
            setValue(name)
        }
        toggleEdit()
    }

    const deleteSlot = () => {
        setSlotsAvailable((prev) => prev.filter((_, idx) => idx !== slotIndex))
        if (slotIndex) {
            setActiveSlotIndex(slotIndex - 1)
        }
    }

    return (
        <>
            <div className={styles.wrapper}>
                <button
                    type="button"
                    onClick={onClick}
                    aria-current={isActive ? 'page' : false}
                    {...rest}
                >
                    {value.replace(/ /g, '\u00A0')}
                </button>
                {editing && (
                    <form onSubmit={submitName}>
                        <input
                            type="text"
                            size={1}
                            value={value}
                            onChange={changeValue}
                            // oxlint-disable-next-line jsx-a11y/no-autofocus
                            autoFocus
                        />
                    </form>
                )}
            </div>
            {isActive && (
                <Flexer divider dividerOffset="sm" gutter={false}>
                    {editing ? (
                        <IconButton
                            size="normal"
                            variant="primary"
                            onClick={submitName}
                            aria-label={t('entity-event.save-slot-name')}
                            style={{
                                marginLeft: '-6px',
                            }}
                        >
                            <CheckIcon />
                        </IconButton>
                    ) : (
                        <IconButton
                            ref={editButton}
                            size="normal"
                            variant="secondary"
                            onClick={toggleEdit}
                            aria-label={t('entity-event.edit-slot-name', {
                                name,
                            })}
                            style={{
                                marginLeft: '-6px',
                            }}
                        >
                            <EditSmallIcon />
                        </IconButton>
                    )}
                    <IconButton
                        size="normal"
                        variant="secondary"
                        onClick={deleteSlot}
                        aria-label={t('entity-event.delete-slot', {
                            name,
                        })}
                    >
                        <DeleteSmallIcon />
                    </IconButton>
                </Flexer>
            )}
        </>
    )
}

export default TabElement
